// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1q58t","title":"ClientReferral_title__2RkIV","itemText":"ClientReferral_itemText__33_C6"};